const module = { name: 'shared/utils/strUtils', exports: {} }; const exports = module.exports;



const RegExes = {
    LEAD_LETTER: /\b\w/g,
    SPACES: /\s+/g,
}
module.exports = {
    properCase(value) {
        return `${value}`.trim().replace(RegExes.LEAD_LETTER, letter => letter.toUpperCase());
    },
    replaceSpaces(value, replacement) {
        return `${value}`.trim().replace(RegExes.SPACES, typeof replacement === 'string' ? replacement : '-');
    },
};
export default module.exports;